import { ReadingPaneRestrictionType } from '../Behaviors.types';
import { getUserConfiguration } from 'owa-session-store';
import { getMailModuleStore } from 'owa-mail-store/lib/store/Store';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import { assertNever } from 'owa-assert';

export const readingPaneRestrictionType = (
    readingPaneRestrictionType: ReadingPaneRestrictionType
) => () => {
    const globalReadingPanePositionReact = getUserConfiguration().UserOptions
        .GlobalReadingPanePositionReact;
    const showReadingPane = getMailModuleStore().showReadingPane;

    switch (readingPaneRestrictionType) {
        case ReadingPaneRestrictionType.Immersive:
            return showReadingPane && globalReadingPanePositionReact == ReadingPanePosition.Off;

        case ReadingPaneRestrictionType.Right:
            return globalReadingPanePositionReact == ReadingPanePosition.Right;

        case ReadingPaneRestrictionType.Hidden:
            return !showReadingPane;

        default:
            throw assertNever(readingPaneRestrictionType);
    }
};
